import * as Redux from '@reduxjs/toolkit';
import { reducer as toastrReducer } from 'react-redux-toastr';
import { routerReducer } from 'react-router-redux';
import * as NotesDuck from './CustomerNotes/customer-notes.duck';
import * as CustomersDuck from './Customers/customers.duck';
import * as EditCustomerDuck from './Customers/edit-customer.duck';
import * as LocationAssignmentSlice from './LocationAssignment/location-assignment.slice';
import * as AddItemRestrictionsDuck from './ManageRestrictions/add-item-restrictions.duck';
import * as CategoryRulesDuck from './ManageRestrictions/category-rules.duck';
import * as RestrictionLocationAssignmentDuck from './ManageRestrictions/location-assignment.duck';
import { addRestrictionByProductNumberReducer } from './ManageRestrictions/Products/RestrictionsReducers';
import { selectSupplierReducer } from './ManageRestrictions/Products/SelectSupplierReducers';
import * as RestrictionListingDuck from './ManageRestrictions/restriction-listing.duck';
import * as MassChangeHomeDuck from './MassChange/mass-change-home.duck';
import * as MassChangeDuck from './MassChange/mass-change.duck';
import { massImportSlice } from './MassImport/mass-import-page-slice';
import * as MetaProductListingSlice from './MetaProductListing/metaproduct-listing.slice';
import { addBySupcReducer } from './reducers/AddBySupcReducers';
import { adminReducer } from './reducers/AdminReducers';
import { blueprintManagementReducer } from './reducers/BlueprintReducers';
import { customCategoryManagementReducer } from './reducers/CustomCategoryManagementReducers';
import { layoutReducer } from './reducers/LayoutReducer';
import { loginReducer } from './reducers/LoginReducers';
import { pricingReducer } from './reducers/PricingReducers';
import { syscoSelfServiceReducer } from './reducers/SyscoSelfServiceReducers';
import { timeoutReducer } from './reducers/TimeoutReducer';
import { slice as seqChartEditSlice } from './SequenceCharts/createOrEdit/editSequenceOpcosPageSlice';
import { slice as seqChartDetailsSlice } from './SequenceCharts/details/sequenceEditPageSlice';
import { slice as seqChartListSlice } from './SequenceCharts/list/listingPageSlice';
import { addBySupcModalSlice } from './Slices/AddBySupcModalSlice';
import { alertsPageSlice } from './Slices/AlertsPageSlice';
import { blueprintManagementPageSlice } from './Slices/BlueprintManagementPageSlice';
import { blueprintsSlice } from './Slices/BlueprintsSlice';
import { customerItemNumbersPageSlice } from './Slices/CustomerItemNumbersPageSlice';
import { customerSettingsSlice } from './Slices/CustomerSettingsSlice';
import { discontinuedAlertsSlice } from './Slices/DiscontinuedAlertSlice';
import { distributionCentersSlice } from './Slices/DistributionCentersSlice';
import { glGroupsSlice } from './Slices/GlGroupsSlice';
import { InvoiceSequenceSlice } from './Slices/InvoiceSequenceSlice';
import { metaProductsSlice } from './Slices/MetaProductsSlice';
import { EditNetUnitsSlice } from './Slices/OGMAI/EditNetUnitsSlice';
import { OGMAIHistorySlice } from './Slices/OGMAI/HistorySlice';
import { OGMAISuggestionsSlice } from './Slices/OGMAI/SuggestionsSlice';
import { productAvailabilitiesSlice } from './Slices/ProductAvailabilitiesSlice';
import { productDetailsSlice } from './Slices/ProductDetailsSlice';
import { productHeaderPricesSlice } from './Slices/ProductHeaderPricesSlice';
import { productHeadersSlice } from './Slices/ProductHeadersSlice';
import { productLinePricesSlice } from './Slices/ProductLinePricesSlice';
import { productLinesSlice } from './Slices/ProductLinesSlice';
import { nutritionalInformationSlice } from './Slices/ProductNutritionalInformationSlice';
import { productSearchPageSlice } from './Slices/ProductSearchPageSlice';
import { productUsageSlice } from './Slices/ProductUsageHistorySlice';
import { RearrangeSlice } from './Slices/Rearrange/RearrangeSlice';
import { dynamicRearrangeSlice } from './Slices/Rearrange/DynamicRearrangeSlice';
import { reducer as reportsPageReducer } from './Slices/ReportsPage';
import { restrictionListsPageSlice } from './Slices/RestrictionListsPageSlice';
import { restrictionListsSlice } from './Slices/RestrictionListsSlice';
import { SupplierCategoriesSlice } from './Slices/SupplierCategoriesSlice';
import { suppliersSlice } from './Slices/SuppliersSlice';
import * as GlobalActivitySlice from './GlobalActivity/global-activity.slice';
import * as ItemRestrictionsSlice from './ManageRestrictions/item-restrictions.slice';
import * as NewRestrictionListSlice from './ManageRestrictions/new-restriction-list.slice';
import * as SyscoManageLocationsSlice from './containers/SyscoSelfService/ManageLocations/sysco-manage-locations.slice';
import * as ProductDetailsSlideoutSlice from '~/Slices/ProductDetailsSlideoutSlice';
import { reducer as metaProductPageReducer } from '~/Slices/MetaProductPage';
import { tagsModalSlice } from '~/Slices/TagsModalSlice';

export const slices = {
	[MetaProductListingSlice.slice.name]: MetaProductListingSlice,
	[ProductDetailsSlideoutSlice.slice.name]: ProductDetailsSlideoutSlice,
	[LocationAssignmentSlice.slice.name]: LocationAssignmentSlice,
	[GlobalActivitySlice.slice.name]: GlobalActivitySlice,
	[ItemRestrictionsSlice.slice.name]: ItemRestrictionsSlice,
	[NewRestrictionListSlice.slice.name]: NewRestrictionListSlice,
	[SyscoManageLocationsSlice.slice.name]: SyscoManageLocationsSlice,
};

export function createRootReducer() {
	return Redux.combineReducers({
		[MetaProductListingSlice.slice.name]: MetaProductListingSlice.slice.reducer,
		[ProductDetailsSlideoutSlice.slice.name]:
			ProductDetailsSlideoutSlice.slice.reducer,
		[LocationAssignmentSlice.slice.name]: LocationAssignmentSlice.slice.reducer,
		[GlobalActivitySlice.slice.name]: GlobalActivitySlice.slice.reducer,
		[ItemRestrictionsSlice.slice.name]: ItemRestrictionsSlice.slice.reducer,
		[NewRestrictionListSlice.slice.name]: NewRestrictionListSlice.slice.reducer,
		[SyscoManageLocationsSlice.slice.name]:
			SyscoManageLocationsSlice.slice.reducer,
		blueprintManagement: blueprintManagementReducer,
		blueprintManagementPage: blueprintManagementPageSlice.reducer,
		customerNotes: NotesDuck.CustomerNotesPageReducer,
		sessionTimeout: timeoutReducer,
		customers: CustomersDuck.customersReducer,
		addBySupc: addBySupcReducer,
		restrictionsHome: RestrictionListingDuck.RestrictionReducer,
		restrictionLists: restrictionListsSlice.reducer,
		restrictionListsPage: restrictionListsPageSlice.reducer,
		addRestrictionsByProductNumber: addRestrictionByProductNumberReducer,
		rearrange: RearrangeSlice.reducer,
		dynamicRearrange: dynamicRearrangeSlice.reducer,
		admin: adminReducer,
		login: loginReducer,
		pricing: pricingReducer,
		syscoSelfService: syscoSelfServiceReducer,
		customCategoryManagement: customCategoryManagementReducer,
		supplierSelection: selectSupplierReducer,
		categoryRules: CategoryRulesDuck.CategoryRulePageReducer,
		restrictionLocationAssignment:
			RestrictionLocationAssignmentDuck.RestrictionLocationReducer,
		addItemRestrictions: AddItemRestrictionsDuck.AddItemRestrictionReducer,
		layout: layoutReducer,
		editCustomer: EditCustomerDuck.EditCustomerReducer,
		MassChange: MassChangeDuck.MassChangeReducer,
		massChangeHome: MassChangeHomeDuck.MassChangeHomeReducer,
		metaProductPage: metaProductPageReducer,
		productSearchPage: productSearchPageSlice.reducer,
		metaProducts: metaProductsSlice.reducer,
		productHeaders: productHeadersSlice.reducer,
		productLines: productLinesSlice.reducer,
		productHeaderPrices: productHeaderPricesSlice.reducer,
		productLinePrices: productLinePricesSlice.reducer,
		suppliers: suppliersSlice.reducer,
		customerSettings: customerSettingsSlice.reducer,
		blueprints: blueprintsSlice.reducer,
		distributionCenters: distributionCentersSlice.reducer,
		productDetails: productDetailsSlice.reducer,
		productDetailsSlideout: ProductDetailsSlideoutSlice.slice.reducer,
		productNutrionalInformation: nutritionalInformationSlice.reducer,
		productAvailabilities: productAvailabilitiesSlice.reducer,
		glGroups: glGroupsSlice.reducer,
		customerItemNumbersPage: customerItemNumbersPageSlice.reducer,
		addBySupcModal: addBySupcModalSlice.reducer,
		reportsPage: reportsPageReducer,
		alertsPage: alertsPageSlice.reducer,
		discontinuedAlerts: discontinuedAlertsSlice.reducer,
		optimizationHistory: OGMAIHistorySlice.reducer,
		OGMAISuggestions: OGMAISuggestionsSlice.reducer,
		EditNetUnits: EditNetUnitsSlice.reducer,
		SeqChartListSlice: seqChartListSlice.reducer,
		SeqChartDetailsSlice: seqChartDetailsSlice.reducer,
		SeqChartEditSlice: seqChartEditSlice.reducer,
		productUsageHistory: productUsageSlice.reducer,
		invoiceSequences: InvoiceSequenceSlice.reducer,
		supplierCategories: SupplierCategoriesSlice.reducer,
		massImport: massImportSlice.reducer,
		tagsModal: tagsModalSlice.reducer,
		routing: routerReducer,
		toastr: toastrReducer,
	});
}

export function createLoginReducer() {
	return Redux.combineReducers({
		login: loginReducer,
		routing: routerReducer,
		toastr: toastrReducer,
	});
}
